class CaptchaRequest {

    postCaptcha = (token) => {
        return {
            "datos": {
                "tokenRespuesta" : token
            }
        }
    }

}

export default CaptchaRequest;